import {
    GET_CLIENT_FILED_FORM_SUCCESS,
    GET_CLIENT_INVITE_FORM_SUCCESS,
    GET_FORM_BY_ID_SUCCESS,
    GET_FORM_SETTINGS_SUCCESS,
    GET_FORMS_DEFAULT_SUCCESS,
    GET_FORMS_SUCCESS,
    RESET_FORM_BY_ID,
    RESET_FORMS,
    RESET_FORMS_DEFAULT,
} from './form.type';

const initialState = {
    forms: [],
    form: null,

    formDefault: null,
    formSettings: null,
    clientInviteForm: null,
    clientFiledForm: null,

    formById: null,
};

export const formReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_FORMS_SUCCESS:
            return {
                ...state,
                forms: action.payload,
            };

        case RESET_FORMS:
            return {
                ...state,
                forms: [],
            };

        case GET_FORMS_DEFAULT_SUCCESS:
            return {
                ...state,
                formDefault: action.payload,
            };

        case RESET_FORMS_DEFAULT:
            return {
                ...state,
                formDefault: null,
            };

        case GET_FORM_BY_ID_SUCCESS:
            return {
                ...state,
                form: action.payload,
            };

        case RESET_FORM_BY_ID:
            return {
                ...state,
                form: action.payload,
            };

        case GET_FORM_SETTINGS_SUCCESS:
            return {
                ...state,
                formSettings: action.payload,
            };

        case GET_CLIENT_INVITE_FORM_SUCCESS:
            return {
                ...state,
                clientInviteForm: action.payload,
            };

        case GET_CLIENT_FILED_FORM_SUCCESS:
            return {
                ...state,
                clientFiledForm: action.payload,
            };

        default:
            return state;
    }
};
